export enum Mode {
    ALL = 'all',
    HOSPITAL = 'hospital',
    SINGLE = 'single'
}
